<div class="scrollbar-hidden fixed hidden h-full overflow-y-auto lg:block">
  <div class="flex h-full flex-col">
    <div class="mt-2 flex items-center justify-between xl:mb-8 3xl:mb-10">
      <img
        class="ml-4 w-[70%] py-4"
        src="assets/images/Logo_SegurosReservas.svg"
        alt="Logo"
      />
    </div>

    <div
      class="flex h-full w-[280px] flex-col justify-between px-4 pb-4 3xl:w-[344px] 3xl:pl-8 3xl:pr-4"
    >
      <div>
        <!-- Ítems principales -->
        <ul class="ml-1 mr-12 space-y-2 text-primary-normal">
          @for (
            item of menuItems.items.slice(0, 8);
            track item;
            let i = $index
          ) {
            <li>
              @if (i === 6 && hasPermission("Salud")) {
                <p
                  class="-ml-3 mb-2 mt-4 px-2 font-freightSansProSemibold text-[15px] uppercase text-primary-disabled"
                >
                  SALUD JUST
                </p>
              }
              <div
                class="transition-hover rounded-lg duration-300 hover:bg-[#ecf1f7] 3xl:text-lg"
              >
                @if (item.showInMenu && hasPermission(item.category)) {
                  <button
                    class="flex w-full items-center p-2 text-left"
                    [ngClass]="{
                      'cursor-default': !item.route,
                      'cursor-pointer': item.route,
                    }"
                    (click)="navigateToPage(item)"
                  >
                    @if (item.icon) {
                      <img
                        class="mr-4"
                        [src]="
                          item.name === 'Rescate 365'
                            ? 'assets/icons/rescate-default.svg'
                            : currentPage?.name === item.name
                              ? 'assets/icons/' + item.icon + '-selected.svg'
                              : 'assets/icons/' + item.icon + '-default.svg'
                        "
                        [alt]="item.icon"
                      />
                    }
                    <span
                      [ngClass]="{
                        'font-freightSansProBold':
                          currentPage?.name === item.name,
                        'font-freightSansProMedium':
                          currentPage?.name !== item.name,
                      }"
                    >
                      {{ item.name }}
                    </span>
                  </button>
                }
              </div>
            </li>
          }
        </ul>
      </div>

      <div>
        <!-- Contáctanos manual -->
        <div
          class="transition-hover mb-2 ml-1 mr-12 rounded-lg text-primary-normal duration-300 hover:bg-[#ecf1f7] 3xl:text-lg"
        >
          <button
            class="flex w-full items-center p-2 text-left"
            (click)="navigateToPage(menuItems.items[8])"
          >
            <img
              class="mr-4"
              [src]="
                currentPage?.name === 'Contáctanos'
                  ? 'assets/icons/contacto-selected.svg'
                  : 'assets/icons/contacto-default.svg'
              "
              alt="contacto"
            />
            <span
              [ngClass]="{
                'font-freightSansProBold': currentPage?.name === 'Contáctanos',
                'font-freightSansProMedium':
                  currentPage?.name !== 'Contáctanos',
              }"
            >
              {{ menuItems.items[8].name }}
            </span>
          </button>
        </div>

        <!-- Cerrar sesión -->
        <div class="ml-1 mr-12">
          <button
            (click)="signOut()"
            class="transition-hover flex w-full items-center rounded-lg p-3 text-left duration-300 hover:bg-[#ecf1f7] 3xl:text-lg"
          >
            <img
              class="mr-4"
              src="assets/icons/cerrar-sesion-default.svg"
              alt="cerrar-sesion-icon"
            />
            <span class="font-freightSansProMedium text-primary-normal">
              Cerrar sesión
            </span>
          </button>
        </div>

        <!-- Redes sociales -->
        <div class="w-5/6">
          <div class="mt-5 w-full rounded-lg bg-[#33587a] px-6 pb-6 pt-5">
            <p class="mb-4 font-freightSansProMedium italic text-white">
              Síguenos en nuestras redes sociales
            </p>
            <div class="flex items-center justify-between">
              @for (network of SOCIAL_NETWORKS; track network) {
                <a [href]="network.url" target="_blank">
                  <img
                    [src]="'assets/icons/' + network.icon + '.svg'"
                    [alt]="network.alt"
                  />
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
